import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  FormLabel,
  GridItem,
  DatePicker,
  isArray,
  FormControl,
} from '@tq/ui-components';

import { TitleContainer } from 'pages/Search/Search.styles';
import { filterDateFromState, filterDateToState } from 'store';
import { useRecoilState } from 'recoil';
import { useLocaleDatePickerFormat } from 'config/DateFormats/useDatePickerFormat';

export const ConsultationDateFilter: React.FC = () => {
  const { t } = useTranslation('filter');

  const [dateFrom, setDateFrom] = useRecoilState(filterDateFromState);
  const [dateTo, setDateTo] = useRecoilState(filterDateToState);

  const handleDateChange = (date: Date | [Date, Date] | null, dateType: 'to' | 'from') => {
    if (date && !isArray(date)) {
      switch (dateType) {
        case 'from':
          setDateFrom(date);
          break;
        case 'to':
          setDateTo(date);
          break;
      }
    }
  };

  const epoch = new Date('1970-01-01');
  const now = new Date();
  const datePickerFormat = useLocaleDatePickerFormat();

  return (
    <Grid>
      <FormControl>
        <TitleContainer line-height='1rem' margin-bottom='0'>
          {t('date_range_title', 'Date range')}
        </TitleContainer>
        <Grid gridGap={3} sx={{ '.react-datepicker-wrapper': { display: 'block' } }}>
          <GridItem>
            <FormLabel id='date_from_label'>{t('date_range_from_title', 'From')}:</FormLabel>
            <DatePicker
              aria-labelledby='date_from_label'
              dateFormat={datePickerFormat.dateFormat}
              placeholderText={datePickerFormat.placeHolderText}
              minDate={epoch}
              maxDate={dateTo ?? now}
              yearDropDownFromTo={[
                epoch.getFullYear(),
                dateTo?.getFullYear() ?? now.getFullYear(),
              ]}
              onChange={(date: unknown) => handleDateChange(date as Date, 'from')}
              selected={dateFrom}
            />
          </GridItem>
          <GridItem>
            <FormLabel id='date_to_label'>{t('date_range_to_title', 'To')}: </FormLabel>
            <DatePicker
              aria-labelledby='date_to_label'
              dateFormat={datePickerFormat.dateFormat}
              placeholderText={datePickerFormat.placeHolderText}
              minDate={dateFrom ?? epoch}
              maxDate={now}
              yearDropDownFromTo={[
                dateFrom?.getFullYear() ?? epoch.getFullYear(),
                now.getFullYear(),
              ]}
              onChange={(date: unknown) => handleDateChange(date as Date, 'to')}
              selected={dateTo}
            />
          </GridItem>
        </Grid>
      </FormControl>
    </Grid>
  );
};
